export default {
  title: 'Toimitusosoite',
  buttons: {
    save: 'Tallenna',
  },
};
